import { DatePipe } from '@angular/common';
import { Pipe, PipeTransform } from '@angular/core';
@Pipe({ name: 'customDate' })

export class CustomDatePipline implements PipeTransform {
  transform(date: Date, format: string): string {
    if (!date || date === null)
      return ""
    var pipe = new DatePipe('en-US');
    var result = pipe.transform(date, format);
    var lang = localStorage.getItem("lang");
    if (lang === "ar") {
      result = result.replace("AM", "ص")
        .replace("PM", "م")
        .replace("Jan", "يناير")
        .replace("Feb", "فبراير")
        .replace("Mar", "مارس")
        .replace("Apr", "أبريل")
        .replace("May", "مايو")
        .replace("Jun", "يونيو")
        .replace("Jul", "يوليو")
        .replace("Aug", "أغسطس")
        .replace("Sept", "سبتمبر")
        .replace("Oct", "أكتوبر")
        .replace("Nov", "نوفمبر")
        .replace("Dec", "ديسمبر")
    }
    return result;
  }
}
